module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_32.3a24b028.mp3";